import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import { routerUtil } from "../../util/routerUtil";
export var MobileHeaderBackArrow = function MobileHeaderBackArrow(props) {
  var history = useHistory();
  var location = useLocation();
  var routeInfo = routerUtil.getCurrentRouteInfo(location);
  var isAEatRoute = routeInfo.isAEatRoute,
      isACaterRoute = routeInfo.isACaterRoute,
      isAShopRoute = routeInfo.isAShopRoute,
      segments = routeInfo.segments,
      isCaterLandingPage = routeInfo.isCaterLandingPage,
      isEatLandingPage = routeInfo.isEatLandingPage,
      isCategoryPage = routeInfo.isCategoryPage,
      lastUrlSegment = routeInfo.lastUrlSegment,
      isAMobilePayRoute = routeInfo.isAMobilePayRoute;
  var isDetailPage = routerUtil.isProductDetailPage();

  var handleClick = function handleClick(e) {
    if (isDetailPage) {
      history.goBack();
    } else if (isEatLandingPage || isCaterLandingPage || isAMobilePayRoute) {
      history.push('/');
    } else if (isAEatRoute) {
      history.push('/menu');
    } else if (isACaterRoute) {
      history.push('/cater');
    } else {
      history.goBack();
    }
  };

  return /*#__PURE__*/React.createElement("button", {
    style: {
      border: "unset",
      backgroundColor: "unset"
    },
    onClick: handleClick
  }, routeInfo.isAccountHomePage ? null : /*#__PURE__*/React.createElement(FiArrowLeft, {
    className: "cb-color-brown-500",
    size: (props === null || props === void 0 ? void 0 : props.size) || 30
  }));
};